import React, { Component } from 'react';

export const BreadCrumb = ({step, backToProduct}) => {
    return (
        <ul className="breadcrumbs">
            <li className={step === 1 ? 'current' : ''} onClick={e => step > 1 ? backToProduct() : ''}>メニューを選択</li>
            <li className={step > 1 ? 'current' : ''}>日時の指定・お客様情報の入力</li>
        </ul>
    )
}
